const type = 'CLOSE_ADVANCE_INVOICE_INSTALLMENT';

const closeAdvanceInvoiceInstallment = () => ({
  type,
});

export { type };
export default closeAdvanceInvoiceInstallment;
